import useFocusHandler from './useFocusHandler';

export default useFocusHandler;